import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { DomUtils } from '../../utils/dom-utils';
import { Themes } from '../../style/theme-consts';
import * as S from './styled';

export const Timeline = ({ items }) => {
  const totalItems = items.length;
  const containerRef = useRef(null);
  const { theme } = DomUtils.useDetectParentTheme(containerRef);
  const dotColor = theme === Themes.LIGHT ? 'var(--midnightGreen)' : 'var(--mainGreen)';

  return (
    <S.TimelineContainer ref={containerRef}>
      {items.map((item, index) => {
        const isLastItem = index === totalItems - 1;
        return (
          <S.Step key={item.key}>
            {item.date != null && (
              <S.DateColumn>
                <S.DateLabel>{item.date}</S.DateLabel>
              </S.DateColumn>
            )}
            <S.Stepper>
              <S.Circle $color={dotColor} />
              <S.Line $color={dotColor} $isLastItem={isLastItem} />
            </S.Stepper>
            <S.Content>{item.content}</S.Content>
          </S.Step>
        );
      })}
    </S.TimelineContainer>
  );
};

Timeline.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      date: PropTypes.node,
      content: PropTypes.node.isRequired
    })
  ).isRequired
};
